import { jsx as _jsx } from "react/jsx-runtime";
import { BtnFactory, SIZE } from './BtnFactory';
export { SIZE };
export function TertiaryLink(props) {
    return _jsx(BtnFactory, { as: 'a', severity: 'tertiary', ...props });
}
//# sourceMappingURL=TertiaryLink.js.map